import React from 'react';
import Modal from '../_layout/_layout';

import * as style from './ModalDownload.module.scss';

import image from '../../../static/images/pieces/image-modal.jpg';
import imageDesktop from '../../../static/images/icons/desktop.svg';
import imageMobile from '../../../static/images/icons/mobile.svg';

const ModalDownload = ({ modalDownloadRef, data }) => {
  return (
    <Modal ref={modalDownloadRef} modalClass={style.modal_download}>
      <div className={style.modal_content}>
        <div className={style.information}>
          <div className={style.information_content}>
            <h2>Lorem ipsum dolor sit amet</h2>

            <p className={style.description}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Vestibulum vitae elit lectus. Aenean a consequat tortor, eget
              sodales augue.
            </p>

            <div className="custom-check-box">
              <div className="custom-check-optionBox-wrapper">
                <input id="quality-1" type="radio" name="quality" />
                <label className="custom-check" htmlFor="quality-1">
                  <div className="input-check"></div>
                  <div className="icon">
                    <img src={imageDesktop} alt="Desktop" />
                  </div>
                  <div className="description">
                    <p className="title">Dispositivo 1</p>
                    <p className="sub-title">HD / 1920 x 1080 px</p>
                  </div>
                </label>
              </div>

              <div className="custom-check-optionBox-wrapper">
                <input id="quality-2" type="radio" name="quality" />
                <label className="custom-check" htmlFor="quality-2">
                  <div className="input-check"></div>
                  <div className="icon">
                    <img src={imageMobile} alt="Mobile" />
                  </div>
                  <div className="description">
                    <p className="title">Dispositivo 2</p>
                    <p className="sub-title">HD / 1920 x 1080 px</p>
                  </div>
                </label>
              </div>
            </div>

            <button
              className="btn btn--primary auto"
              type="submit"
              onClick={() => console.log('descargar')}
            >
              Descargar
            </button>
          </div>
        </div>

        <picture>
          <img src={image} alt="Imagen grande" />
        </picture>
      </div>
    </Modal>
  );
};

export default ModalDownload;
